<template>
  <div>
    <button
      v-if="mini"
      class="font-bold uppercase focus:outline-none text-12 lg:text-14 lg:leading-1.25 py-8 px-8 rounded-full flex
             justify-between cursor-pointer items-center lg:border-2 shadow-md lg:shadow-none lg:bg-transparent"
      :class="isMiniBtnDisabled ? `text-dark-gray bg-gray lg:text-gray lg:border-gray` :
      `transform lg:hover:-translate-y-4 transition duration-300 text-white bg-orange lg:text-orange lg:hover:text-white lg:hover:bg-orange lg:border-orange`"
      :disabled="isMiniBtnDisabled"
      @click="addToCart">
      <i class="fas fa-shopping-cart text-16"></i>
      <i v-if="isLoading" class="ml-10 text-gray text-20 fas fa-spinner fa-spin"></i>
    </button>

    <button
      v-else
      class="text-white font-bold uppercase leading-1.25 py-14 px-26 rounded justify-center flex w-full"
      :class="isLoading ? `cursor-wait bg-gray`: isDisabled ? `bg-black cursor-default` : `cursor-pointer bg-orange`"
      :disabled="isDisabled"
      @click="addToCart">
      <i class="mr-12 fad fa-pallet" v-show="status === 'sold'"></i> 
      <i class="mr-12 far fa-shopping-cart" v-show="status !== 'sold'"></i> {{ label }}
      <i v-if="isLoading" class="ml-10 text-white text-20 fas fa-spinner fa-spin"></i>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    artwork: {required: true},

    // Values: available, reserved, in-cart
    status: {
      type: String,
      required: true,
    },

    mini: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
    }
  },

  methods: {
    addToCart() {
      window.dataLayer.push({
        event: 'add-to-cart',
        artwork: {
          id: this.artwork.slug,
          title: this.artwork.title,
          price: this.artwork.discounted_price ?? this.artwork.original_price,
        }
      })
      if (this.status === 'available') {
        this.isLoading = true
        axios
          .post(`/web/api/cart/${this.artwork.slug}`)
          .then(({data}) => {
            this.$root.$refs.notification.notify({
              title: 'Added to cart!',
              message: 'The selected artwork is added to your cart and reserved for one hour',
              type: 'warning-dark',
            })
            this.$emit('added', data.data)
            window.TheCartLink.increment()
          })
          .catch((error) => {
            console.log(error.response)
            if (error.response.data.message) {
              alert(error.response.data.message)
            } else {
              alert('Unable to add artwork to cart. Please try again later.')
            }
          })
          .finally(() => this.isLoading = false)
      } else if (this.status === 'in-cart') {
        this.isLoading = true
        window.location = '/cart'
      }
    },
  },

  computed: {
    label() {
      if (this.status === 'available') {
        return 'Add to Cart'
      }

      if (this.status === 'in-cart') {
        return 'Checkout'
      }

      if (this.status === 'reserved') {
        return 'Already Reserved'
      }

      if (this.status === 'sold') {
        return 'Sold'
      }
    },

    isDisabled() {
      return this.isLoading || this.status !== 'available' && this.status !== 'in-cart'
    },

    isMiniBtnDisabled() {
      return this.isLoading || this.status !== 'available'
    }
  }
}
</script>
